import script from "./DeviceView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceView.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceView.vue?vue&type=style&index=0&id=5c494a23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c494a23"]])

export default __exports__